<template>
  <div class="discounted-list-pro-item">
    <div class="item-icon">
      <img src="https://img01.yzcdn.cn/vant/cat.jpeg" />
      <div class="discounted-icon">捡漏宝贝</div>
      <div class="discounted-time">
        <div style="float: left">距开始</div>
        <van-count-down :time="time" />
      </div>
    </div>
    <div class="item-desc">
      <div class="pro-name gold-shine-text1">商品名称</div>
      <div class="pro-price-inf">
        <div class="price">到手价：￥ 2222.00</div>
        <div class="old-price"><del>市场价￥5000.00</del></div>
      </div>
      <div class="pro-inf-btn">
        <div class="num">已放漏1.2万件</div>
        <div class="btn" @click="toInf()">查看详情</div>
      </div>
    </div>
    <div class="icon">
      <img src="@/assets/discountedicon.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProLstItemView',
  data () {
    return {
      time: 30 * 60 * 60 * 1000
    }
  },
  methods: {
    toInf () {
      this.$router.push({ name: 'discountinf' }, () => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.discounted-list-pro-item {
  //border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  padding: 0px;
  position: relative;
  display: flex;
  gap: 10px;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 15px;
  .item-icon {
    width: 120px;
    height: 120px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 10px;
    }
    .discounted-icon {
      position: absolute;
      background: #e64c0a;
      color: #fff;
      padding: 5px 15px 5px 8px;
      top: 0;
      left: 0px;
      border-top-left-radius: 10px;
      font-size: 12px;
      clip-path: polygon(0 0, 100% 0, 90% 100%, 0 100%);
    }
    .discounted-time {
      position: absolute;
      width: calc(100% - 16px);
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      left: 0;
      bottom: 0;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      padding: 4px 8px;
      text-align: right;
      font-size: 12px;
      line-height: 20px;
    }
  }
  .item-desc {
    flex: 1;
    .pro-name {
      padding: 8px 0;
      font-size: 16px;
      font-weight: 700;
    }
    .pro-price-inf {
      .price {
        color: #e64c0a;
        font-size: 14px;
        font-weight: 600;
      }
      .old-price {
        color: #7b8c9c;
        font-size: 12px;
      }
    }
    .pro-inf-btn {
      border: 1px solid #e64c0a;
      display: flex;
      margin: 3px 10px 0px 0px;
      font-size: 14px;
      line-height: 18px;
      .num {
        flex: 1;
        text-align: center;
        color: #e64c0a;
        padding: 10px 0;
        font-size: 12px;
        background: linear-gradient(
          to bottom,
          #b8860b 0%,
          #ffd700 25%,
          #fffacd 50%
        );
      }
      .btn {
        flex: 1;
        text-align: center;
        background: #e64c0a;
        padding: 10px 0;
        font-size: 16px;
        color: #fff;
        font-weight: 600;
      }
    }
  }
  .icon {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
    img {
      width: 100%;
    }
  }
}
</style>
<style lang="scss">
.discounted-time {
  .van-count-down {
    color: #fff !important;
  }
}
</style>
